import * as React from "react";

import { CustomButton } from "@/components/Button";

export const DiagnosisCompatibilityAgentsGoHomeButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <CustomButton tone="primary" buttonSize="L" fullWidth onClick={onClick}>
    ホームへ
  </CustomButton>
);
